import { render, staticRenderFns } from "./AddToGroupTable.vue?vue&type=template&id=82bd7e82&scoped=true"
import script from "./AddToGroupTable.vue?vue&type=script&lang=js"
export * from "./AddToGroupTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bd7e82",
  null
  
)

export default component.exports